import React from 'react';
import heic2any from 'heic2any';

export default function PhotoUpload({ photos, setPhotos }) {
    const MAX_PHOTOS = 20;

    const normalizePhotoFile = async (file) => {
        const isHeic = file.type === 'image/heic'
            || file.type === 'image/heif'
            || /\.heic$/i.test(file.name)
            || /\.heif$/i.test(file.name);

        if (!isHeic) {
            return file;
        }

        try {
            const converted = await heic2any({
                blob: file,
                toType: 'image/jpeg',
                quality: 0.9
            });
            const blob = Array.isArray(converted) ? converted[0] : converted;
            const safeName = file.name.replace(/\.(heic|heif)$/i, '.jpg');
            return new File([blob], safeName, { type: 'image/jpeg' });
        } catch (error) {
            console.error('HEIC conversion failed:', error);
            throw new Error('Unable to convert HEIC image. Please export as JPG or PNG.');
        }
    };

    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;

        try {
            const remainingSlots = MAX_PHOTOS - photos.length;
            if (remainingSlots <= 0) {
                alert(`Maximum ${MAX_PHOTOS} photos allowed`);
                return;
            }

            const accepted = files.slice(0, remainingSlots);
            if (accepted.length < files.length) {
                alert(`Only ${MAX_PHOTOS} photos allowed. Added ${accepted.length} photo${accepted.length === 1 ? '' : 's'}.`);
            }

            const normalized = await Promise.all(accepted.map(normalizePhotoFile));
            setPhotos((prev) => [...prev, ...normalized]);
        } catch (error) {
            alert(error.message);
        }
    };

    const handleRemove = (index) => {
        setPhotos(photos.filter((_, i) => i !== index));
    };

    return (
        <div className="photo-upload">
            <input
                type="file"
                accept="image/*"
                multiple
                capture="environment"
                onChange={handleFileChange}
            />

            <div className="photo-grid">
                {photos.map((photo, index) => (
                    <div key={index} className="photo-item">
                        <img src={URL.createObjectURL(photo)} alt={`Photo ${index + 1}`} />
                        <button type="button" onClick={() => handleRemove(index)}>Remove</button>
                        <span>{photo.name}</span>
                    </div>
                ))}
            </div>

            <p className="photo-count">
                {photos.length} photo{photos.length === 1 ? '' : 's'} uploaded (max {MAX_PHOTOS})
            </p>
        </div>
    );
}
